// Custom Loading Image Overlay Management
(function() {
  let loadingOverlay = null;
  let hasCustomImage = false;

  // Initialize custom loading image overlay
  function initCustomLoadingImage() {
    const loadingImageUrl = window.themeVariables?.settings?.loadingAnimationImage;
    
    if (loadingImageUrl && loadingImageUrl.trim() !== '') {
      hasCustomImage = true;
      document.body.classList.add('has-custom-loading-image');
      
      // Create overlay element if it doesn't exist
      if (!loadingOverlay) {
        loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'custom-loading-overlay';
        const img = document.createElement('img');
        img.className = 'custom-loading-overlay__image';
        img.src = loadingImageUrl;
        img.alt = 'Loading...';
        loadingOverlay.appendChild(img);
        document.body.appendChild(loadingOverlay);
      }
    } else {
      hasCustomImage = false;
      document.body.classList.remove('has-custom-loading-image');
    }
  }

  // Show custom loading overlay
  function showCustomLoadingOverlay() {
    if (hasCustomImage && loadingOverlay) {
      loadingOverlay.classList.add('active');
      document.body.style.pointerEvents = 'none';
    }
  }

  // Hide custom loading overlay
  function hideCustomLoadingOverlay() {
    if (loadingOverlay) {
      loadingOverlay.classList.remove('active');
      document.body.style.pointerEvents = '';
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomLoadingImage);
  } else {
    initCustomLoadingImage();
  }

  // Expose functions globally
  window.showCustomLoadingOverlay = showCustomLoadingOverlay;
  window.hideCustomLoadingOverlay = hideCustomLoadingOverlay;
  window.hasCustomLoadingImage = function() { return hasCustomImage; };

  window.addEventListener('load', hideCustomLoadingOverlay);
  setTimeout(hideCustomLoadingOverlay, 4000);
})();

// Recover any images stuck invisible from the old fade-in pattern (cached onload miss)
(function () {
  function revealStuckImages() {
    document.querySelectorAll('img.responsive-picture--fade:not(.loaded)').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('loaded');
        img.style.opacity = '1';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealStuckImages);
  } else {
    revealStuckImages();
  }

  window.addEventListener('load', revealStuckImages);
})();

// // cart page block

// if (location.pathname === "/cart" && !location.search) {
//   window.location.href = "/?return_link=cart";
// }

// // Open cart drawer when redirected with ?return_link=cart
// if (new URLSearchParams(location.search).has("return_link")) {
//   const cartDrawerObserver = new MutationObserver(() => {
//     let cartDrawer = document.querySelector("cart-drawer");
//     if (cartDrawer) {
//       cartDrawer.show();
//       cartDrawerObserver.disconnect(); // Stop observing after cart opens
//     }
//   });
//   cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

//   // Remove return_link=cart from the URL
//   const newUrl = location.href.replace(/[?&]return_link=cart/g, "");
//   history.replaceState({}, document.title, newUrl);
// }

// // Handle browser back button to close cart
// window.addEventListener("popstate", function (event) {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer && !location.search.includes("cartOpen=true")) {
//     cartDrawer.close();
//   } else if (event.state?.cart === "show" && cartDrawer) {
//     cartDrawer.show();
//   }
// });

// // Ensure cartOpen=true is removed from URL if cart is closed
// document.addEventListener("DOMContentLoaded", () => {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer && !cartDrawer.classList.contains("active")) {
//     const newUrl = location.href.replace(/[?&]cartOpen=true/g, "");
//     history.replaceState({}, document.title, newUrl);
//   }
// });

// // Open cart and push cartOpen=true into history
// function openCart() {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer) {
//     cartDrawer.show();
//     history.pushState({ cart: "show" }, "", "?cartOpen=true");
//   }
// }

// judgeme js
const ratingProductCard = document.querySelector(".rating-pdp-card");
const judgemeProductReviews = document.getElementById(
  "judgeme_product_reviews"
);
ratingProductCard?.addEventListener("click", function () {
  judgemeProductReviews.scrollIntoView({ behavior: "smooth" });
});
ratingProductCard?.addEventListener("keydown", function (event) {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    judgemeProductReviews.scrollIntoView({ behavior: "smooth" });
  }
});

class RoundRating extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    const value = parseFloat(this.textContent.trim());
    const roundedValue = Math.round(value * 10) / 10;
    this.textContent = roundedValue.toFixed(1);
  }
}

customElements.define("round-rating", RoundRating);

//round number

class RandomNumber extends HTMLElement {
  constructor() {
    super();
    // Include current URL path in storage key
    this.storageKey = `random-number-values-${window.location.pathname}`;

    // Initialize storage for this page if needed
    if (!sessionStorage.getItem(this.storageKey)) {
      sessionStorage.setItem(this.storageKey, JSON.stringify({}));
    }
  }

  generateUniqueId() {
    const allRandomNumbers = document.getElementsByTagName("random-number");
    for (let i = 0; i < allRandomNumbers.length; i++) {
      if (allRandomNumbers[i] === this) {
        return `random-number-${window.location.pathname}-${i}`;
      }
    }
    return `random-number-${window.location.pathname}-${Date.now()}`;
  }

  connectedCallback() {
    const min = parseInt(this.dataset.min) || 0;
    const max = parseInt(this.dataset.max) || 100;

    // Use element's ID or generate a stable one
    const elementId = this.getAttribute("id") || this.generateUniqueId();
    this.setAttribute("id", elementId);

    let storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));

    // Generate new value only if it doesn't exist for this page
    if (!storedValues[elementId]) {
      const newValue = Math.floor(Math.random() * (max - min + 1)) + min;
      storedValues[elementId] = newValue;
      sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
    }

    this.textContent = storedValues[elementId];
  }

  disconnectedCallback() {
    const elementId = this.getAttribute("id");
    const storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));
    if (storedValues && elementId) {
      delete storedValues[elementId];
      // Only remove from storage if no more values exist for this page
      if (Object.keys(storedValues).length === 0) {
        sessionStorage.removeItem(this.storageKey);
      } else {
        sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
      }
    }
  }
}
// Register the custom element
customElements.define("random-number", RandomNumber);

// cart-change-handler.js - OPTIMIZED

document.addEventListener("cart:change", debounce(async (event) => {
  // Capture event data inside debounced function to prevent stale data
  const cartData = event.detail.cart;
  const baseEvent = event.detail.baseEvent;

  // Prevent infinite loops - don't process if this is from auto-removal or sync
  if (baseEvent === "gift-items:auto-remove") {
    return;
  }

  // First handle the case of removing add-ons when main product is gone
  const mainProducts = cartData.items.filter(
    (item) => !item.properties?._main_product && !item.parent_relationship
  );
  const addOns = cartData.items.filter(
    (item) => item.properties?._main_product && !item.parent_relationship?.parent_key
  );
  const nestedChildren = cartData.items.filter(
    (item) => item.parent_relationship?.parent_key
  );

  // If there are add-ons but no main products, remove ALL add-ons
  if (addOns.length > 0 && mainProducts.length === 0) {
    await forceRemoveAllAddons(addOns);
    return; // Exit early after handling this case
  }

  // Check if any add-ons have a main product that no longer exists
  // IMPORTANT: Skip this check immediately after variant:add events to prevent
  // removing add-ons that were just added along with their main product.
  // The addProductsToCart function adds both main product and add-ons together,
  // so we need to skip orphaned checks on variant:add to avoid race conditions.
  // Subsequent cart changes (like item:remove, line-item:change) will handle
  // truly orphaned add-ons.
  if (addOns.length > 0 && mainProducts.length > 0 && baseEvent !== "variant:add") {
    const mainProductHandles = new Set(mainProducts.map(main => main.handle));
    const orphanedAddons = addOns.filter((addon) => {
      return !mainProductHandles.has(addon.properties._main_product);
    });

    if (orphanedAddons.length > 0) {
      await forceRemoveAllAddons(orphanedAddons);
      return; // Exit early after handling this case
    }
  }

  // Handle changes to the main product quantity
  // Skip quantity sync if this event is from a sync operation itself
  if (
    baseEvent !== "addon-quantity:sync" &&
    (baseEvent === "line-item:change" ||
    baseEvent === "variant:add" ||
    baseEvent === "item:remove")
  ) {
    // Group addons by main product handle for efficient lookup
    const addonsByMainProduct = new Map();
    addOns.forEach(addon => {
      const mainHandle = addon.properties._main_product;
      if (!addonsByMainProduct.has(mainHandle)) {
        addonsByMainProduct.set(mainHandle, []);
      }
      addonsByMainProduct.get(mainHandle).push(addon);
    });

    const mainProductKeys = new Set(mainProducts.map((main) => main.key));
    const orphanedNested = nestedChildren.filter(
      (child) => !mainProductKeys.has(child.parent_relationship?.parent_key)
    );
    if (orphanedNested.length > 0 && baseEvent !== "variant:add") {
      await forceRemoveAllAddons(orphanedNested);
      return;
    }

    // For each main product
    for (const mainProduct of mainProducts) {
      const parentInstance = mainProduct.properties?._line_instance;
      const parentsWithHandle = mainProducts.filter((item) => item.handle === mainProduct.handle);
      const relatedAddons = (addonsByMainProduct.get(mainProduct.handle) || []).filter((addon) => {
        if (addon.parent_relationship?.parent_key) return false;
        const instanceId = addon.properties?._line_instance;
        if (instanceId || parentInstance) {
          return Boolean(instanceId) && instanceId === parentInstance;
        }
        return parentsWithHandle.length === 1;
      });
      const relatedNested = nestedChildren.filter((child) => {
        const instanceId = child.properties?._line_instance;
        if (instanceId || parentInstance) {
          return Boolean(instanceId) && instanceId === parentInstance;
        }
        const parentKey = child.parent_relationship?.parent_key;
        return Boolean(parentKey) && parentKey === mainProduct.key;
      });

      if (relatedAddons.length === 0 && relatedNested.length === 0) continue;

      // If main product quantity is 0, remove all its add-ons and nested children
      if (mainProduct.quantity === 0) {
        await forceRemoveAllAddons([...relatedAddons, ...relatedNested]);
        continue;
      }

      // Legacy _main_product add-ons still follow parent quantity in the cart.
      // Nested add-ons are their own lines: they only increase when the same
      // parent + nested combo is added again (Shopify merges matching lines).
      const syncableAddons = relatedAddons.filter((addon) => {
        const title = (addon.product_title || '').toLowerCase();
        const variantTitle = (addon.variant_title || '').toLowerCase();
        const handle = addon.handle || '';
        
        return handle === "make-this-saree-ready-to-wear-copy" ||
               handle === "pre-drape-this-saree" ||
               handle === "customise-blouse" ||
               handle === "remove-cups" ||
               title.includes("ready-to-wear") ||
               title.includes("pre-drape") ||
               title.includes("blouse customization") ||
               title.includes("customise blouse") ||
               title.includes("remove cups") ||
               variantTitle.includes("ready-to-wear");
      });

      if (syncableAddons.length > 0 && baseEvent !== "variant:add") {
        const needsSync = syncableAddons.some(
          (addon) => addon.quantity !== mainProduct.quantity
        );

        if (needsSync) {
          await syncAddonQuantities(syncableAddons, mainProduct.quantity);
        }
      }

      // If this parent line has nested add-ons, keep those nested quantities
      // matched to this line. Other lines of the same product without this
      // nested combo are left alone.
      if (relatedNested.length > 0 && baseEvent === "line-item:change") {
        const needsNestedSync = relatedNested.some(
          (child) => child.quantity !== mainProduct.quantity
        );

        if (needsNestedSync) {
          await syncAddonQuantities(relatedNested, mainProduct.quantity);
        }
      }
    }
  }

  if (baseEvent === "item:add" || baseEvent === "variant:add") {
    // Check confetti type from theme settings
    const confettiType = window.themeVariables?.settings?.confettiType || 'none';
    
    if (confettiType !== 'none' && typeof window.triggerConfetti === 'function') {
      window.triggerConfetti({ type: confettiType });
    }
    
    // Show toast notification on add to cart (if enabled)
    const toastEnabled = window.themeVariables?.settings?.enableToastNotification !== false;
    if (toastEnabled) {
      if (typeof window.hideCustomLoadingOverlay === 'function') {
        window.hideCustomLoadingOverlay();
      }
      showAddToCartToast();
    }
  }

  // Check for gift-wrapping items - should run after all other operations
  await checkAndRemoveGiftWrappingItems(cartData);

  // Update cart drawer freebie UI and clean up any legacy freebie cart line items
  await processFreebies(cartData);
  updateFreebieLineItemsUI(cartData);

  // Reinitialize carousels after cart changes
  // Use a small timeout to ensure DOM updates from cart operations are complete
  setTimeout(() => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && window.CustomCarousel && typeof CustomCarousel.reinitIn === 'function') {
      CustomCarousel.reinitIn(drawer);
    }
  }, 200);
  
}, 150)); // Debounce for 150ms to reduce frequency

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Helper function to force remove all add-ons (sets quantity to 0)
async function forceRemoveAllAddons(addons) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Build updates object with all quantities set to 0
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = 0;
    });

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) throw new Error("Failed to update cart");

    const updatedCartContent = await response.json();

    // Dispatch cart change event to update the UI
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "item:remove",
          cart: updatedCartContent,
        },
      })
    );

    // Update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error removing add-ons:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// Helper function to sync addon quantities
async function syncAddonQuantities(addons, newQuantity) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Update all addons to the new quantity
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = newQuantity;
    });

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update cart");
    }

    const updatedCartContent = await response.json();

    // Dispatch a special event to prevent re-processing by the sync logic
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "addon-quantity:sync",
          cart: updatedCartContent,
        },
      })
    );

    // Force update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error syncing addon quantities:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// Size Chart Toggle in inches and cms
if (document.querySelector(".toggle-tab-inches-cm")) {
  window.handleSizeToggle();
}

// Tab functionality for size chart (converted from jQuery)
window.handleSizeChartTabs = function () {
  const tabs = document.querySelectorAll('ul.tabs li');
  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      const tabId = this.getAttribute('data-tab');
      
      // Remove current class from all tabs
      tabs.forEach((t) => t.classList.remove('current'));
      // Remove current class from all tab contents
      document.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.remove('current');
      });
      
      // Add current class to clicked tab
      this.classList.add('current');
      // Add current class to corresponding tab content
      const tabContent = document.getElementById(tabId);
      if (tabContent) {
        tabContent.classList.add('current');
      }
    });
  });
};

// Initialize size chart tabs when data-tab="tab-2" is found
if (document.querySelector('ul.tabs li[data-tab="tab-2"]')) {
  window.handleSizeChartTabs();
}

// typewriter component
class TypewriterComponent extends HTMLElement {
  constructor() {
    super();
    this.texts = Array.from(this.querySelectorAll("p")).map(
      (message) => message.innerHTML
    );
    this.currentTextIndex = 0;
    this.currentCharIndex = 0;
    this.isDeleting = false;
    this.typeSpeed = 100; // Adjust typing speed (in milliseconds)
    this.deleteSpeed = 50; // Adjust deleting speed (in milliseconds)
    this.pauseBetweenTexts = 2000; // Pause between texts (in milliseconds)
    this.type();
  }

  type() {
    const currentText = this.texts[this.currentTextIndex];
    const displayText = this.isDeleting
      ? currentText.substring(0, this.currentCharIndex - 1)
      : currentText.substring(0, this.currentCharIndex + 1);

    this.innerHTML = displayText;

    if (!this.isDeleting) {
      this.currentCharIndex++;
      if (this.currentCharIndex === currentText.length) {
        this.isDeleting = true;
        setTimeout(() => this.type(), this.pauseBetweenTexts);
      } else {
        setTimeout(() => this.type(), this.typeSpeed);
      }
    } else {
      this.currentCharIndex--;
      if (this.currentCharIndex === 0) {
        this.isDeleting = false;
        this.currentTextIndex = (this.currentTextIndex + 1) % this.texts.length;
        setTimeout(() => this.type(), this.typeSpeed);
      } else {
        setTimeout(() => this.type(), this.deleteSpeed);
      }
    }
  }
}

customElements.define("typewriter-component", TypewriterComponent);


// Add this function to check and remove gift wrap and bag items when they're alone in cart
async function checkAndRemoveGiftWrappingItems(cartData) {
  // Check if cart has items
  if (!cartData || !cartData.items || cartData.items.length === 0) return;

  // Filter all gift wrap and bag items (items with _is_gift_wrap or _is_bag property)
  const giftWrapAndBagItems = cartData.items.filter(
    (item) => item.properties?._is_gift_wrap === 'Yes' || item.properties?._is_bag === 'Yes'
  );

  // Get all main products (items that are not add-ons, not gift wraps, not bags)
  const regularItems = cartData.items.filter(
    (item) => !item.properties?._main_product &&
              !item.parent_relationship &&
              item.properties?._is_gift_wrap !== 'Yes' &&
              item.properties?._is_bag !== 'Yes'
  );

  // If there are gift/bag items but NO regular items (only gifts/bags in cart), remove them
  if (giftWrapAndBagItems.length > 0 && regularItems.length === 0) {
    
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      // Prepare updates to set gift wrap and bag items quantities to 0
      const updates = giftWrapAndBagItems.reduce((acc, item) => {
        acc[item.key] = 0;
        return acc;
      }, {});

      // Update cart to remove gift wrap and bag items
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error("Failed to update cart");
      
      const updatedCartContent = await response.json();

      // Dispatch cart change event to update the UI
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "gift-items:auto-remove",
            cart: updatedCartContent,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
    } catch (error) {
      console.error("Error removing gift wrap and bag items:", error);
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      if (window.themeVariables?.settings.showErrorMessage) {
        alert(error.message);
      }
    }
  }
}

// section scroller - unified for all pages: top 50% scrolls to bottom, bottom 50% scrolls to top
class SectionScroller extends HTMLElement {
  constructor() {
    super();
    this.hasBeenRevealed = false;
    this.addEventListener("click", this.handleClick.bind(this));
    this.scrollHandler = this.handleScroll.bind(this);
  }

  connectedCallback() {
    window.addEventListener("scroll", this.scrollHandler, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.scrollHandler);
  }

  handleClick() {
    if (this.isInTopHalf) {
      window.scrollTo({
        top: document.documentElement.scrollHeight - window.innerHeight,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const maxScroll = scrollHeight - clientHeight;

    // Top half: 0 to 50% of scrollable area
    this.isInTopHalf = maxScroll <= 0 || scrollTop < maxScroll * 0.5;
    this.updateArrowDirection();
  }

  updateArrowDirection() {
    // Hidden until first scroll past 50%; then always visible
    if (!this.hasBeenRevealed && !this.isInTopHalf) {
      this.hasBeenRevealed = true;
    }
    if (!this.hasBeenRevealed) {
      this.style.opacity = "0";
      this.style.pointerEvents = "none";
      return;
    }
    this.style.opacity = "1";
    this.style.pointerEvents = "auto";
    // Top half: arrow down (180deg), click scrolls to bottom. Bottom half: arrow up (0deg), click scrolls to top
    this.style.transform = this.isInTopHalf ? "scale(1) rotateZ(180deg)" : "scale(1) rotateZ(0deg)";
  }
}

customElements.define("section-scroller", SectionScroller);

class BottomCart extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateHandler = this.handleCartUpdate.bind(this);
    this.bundleSectionsHandler = this.handleBundleSections.bind(this);
    this.refreshCartHandler = this.handleRefreshCart.bind(this);
  }

  connectedCallback() {
    // Add event listeners
    document.addEventListener("cart:change", this.cartUpdateHandler);
    document.addEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.addEventListener("cart:refresh", this.refreshCartHandler);
  }

  disconnectedCallback() {
    // Remove event listeners
    document.removeEventListener("cart:change", this.cartUpdateHandler);
    document.removeEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.removeEventListener("cart:refresh", this.refreshCartHandler);
  }

  handleBundleSections(event) {
    // Add this section's ID to the sections that should be updated
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );
    event.detail.sections.push(sectionId);
  }

  handleCartUpdate(event) {
    const cartData = event.detail.cart;
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Get the updated HTML for this section
    const sectionHtml = cartData.sections[sectionId];

    if (sectionHtml) {
      const domElement = new DOMParser().parseFromString(
        sectionHtml,
        "text/html"
      );
      const bottomCart = domElement.querySelector("bottom-cart");
      if (bottomCart) {
        this.innerHTML = bottomCart.innerHTML;
      }
    }
  }

  async handleRefreshCart() {
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Fetch the latest cart section HTML
    const response = await fetch(
      `${window.Shopify.routes.root}?section_id=${sectionId}`
    );
    const html = await response.text();

    // Parse and update the section content
    const domElement = new DOMParser().parseFromString(html, "text/html");
    const bottomCart = domElement.querySelector("bottom-cart");
    if (bottomCart) {
      this.innerHTML = bottomCart.innerHTML;
    }
  }
}

// Register the custom element if it hasn't been registered yet
if (!customElements.get("bottom-cart")) {
  customElements.define("bottom-cart", BottomCart);
}

// Toast notification for add to cart
let toastTimeout = null;

function showAddToCartToast() {
  // Remove any existing toast
  const existingToast = document.querySelector('.atc-toast');
  if (existingToast) {
    existingToast.remove();
  }
  
  // Clear any pending timeout
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
  }

  // Get toast settings
  const settings = window.themeVariables?.settings || {};
  const backgroundImage = settings.toastBackgroundImage || '';
  const hasBackgroundImage = backgroundImage && backgroundImage !== null && backgroundImage.trim() !== '';

  // Create toast element
  const toast = document.createElement('div');
  toast.className = 'atc-toast';
  
  // Apply background image styles if available (using recommended dimensions: 400x100px)
  if (hasBackgroundImage) {
    toast.style.backgroundImage = `url(${backgroundImage})`;
    toast.style.backgroundSize = 'cover';
    toast.style.backgroundPosition = 'center';
    toast.style.backgroundRepeat = 'no-repeat';
    toast.style.width = '400px';
    toast.style.height = '100px';
  }

  // Build toast content - only show text if no background image
  const messageContent = hasBackgroundImage 
    ? '' 
    : `
      <div class="atc-toast__message">
        <svg class="atc-toast__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6667 5.83333L7.50004 15L3.33337 10.8333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Added to cart!</span>
      </div>
    `;

  toast.innerHTML = `
    <div class="atc-toast__content">
      ${messageContent}
      <button class="atc-toast__close" aria-label="Close notification" type="button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="atc-toast__progress">
      <div class="atc-toast__progress-bar"></div>
    </div>
  `;

  // Add to body
  document.body.appendChild(toast);

  // Trigger animation
  requestAnimationFrame(() => {
    toast.classList.add('atc-toast--show');
  });

  // Close button handler
  const closeBtn = toast.querySelector('.atc-toast__close');
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    closeToast(toast);
  });

  // Click on toast to open cart
  toast.addEventListener('click', (e) => {
    // Don't open cart if clicking the close button
    if (e.target.closest('.atc-toast__close')) {
      return;
    }
    openCartDrawer();
    closeToast(toast);
  });

  // Auto-close after 3 seconds
  toastTimeout = setTimeout(() => {
    closeToast(toast);
    toastTimeout = null;
  }, 3000);
}

window.showAddToCartToast = showAddToCartToast;

function closeToast(toast) {
  if (!toast) return;
  
  // Clear timeout if toast is manually closed
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
  }
  
  toast.classList.add('atc-toast--hide');
  setTimeout(() => {
    if (toast.parentNode) {
      toast.remove();
    }
  }, 300);
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.show === 'function') {
    cartDrawer.show();
  }
}

// Confetti function for celebrations
window.triggerConfetti = function(options = {}) {
  // Get confetti type from options or default to 'default'
  const confettiType = options.type || 'default';
  
  // Define confetti configurations for different types
  const confettiConfigs = {
    'default': {
      particleCount: 200,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 50,
      colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7']
    },
    'valentine': {
      particleCount: 250,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 60,
      colors: ['#ffb3d9', '#ff69b4', '#ff1493', '#ff6b9d', '#ffc0cb', '#ff69b4'],
      emojis: ['💖', '❤️', '💕', '💗', '💓', '💝'],
      emojiSize: 50
    },
    'independence': {
      particleCount: 300,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 60,
      colors: ['#FF9933', '#FFFFFF', '#138808'], // Saffron, White, Green
      shapes: ['circle', 'square']
    },
    'festival': {
      particleCount: 250,
      spread: 180,
      origin: { y: 1.0, x: 0.5 },
      startVelocity: 55,
      colors: ['#FFD700', '#FFA500', '#FF6347', '#FF69B4', '#FF1493', '#FFB6C1'],
      emojis: ['🌸', '🌺', '🪔', '🕯️', '🌼', '🌻'],
      emojiSize: 50
    }
  };
  
  // Get base config for the type
  const baseConfig = confettiConfigs[confettiType] || confettiConfigs['default'];
  
  // Merge with passed options (options override base config)
  const confettiOptions = { ...baseConfig, ...options };
  // Remove 'type' from options as it's not a valid confetti parameter
  delete confettiOptions.type;
  
  if (typeof confetti === 'function') {
    confetti(confettiOptions);
  } else {
    // Wait for confetti library to load
    const maxWait = 3000; // 3 seconds max
    const interval = 100; // Check every 100ms
    let waited = 0;
    
    const checkConfetti = setInterval(() => {
      // Increment waited before checking to ensure accurate timing
      waited += interval;
      
      if (typeof confetti === 'function') {
        clearInterval(checkConfetti);
        confetti(confettiOptions);
      } else if (waited >= maxWait) {
        clearInterval(checkConfetti);
        console.log('Confetti library failed to load');
      }
    }, interval);
  }
};

// function deleteCookie(name) {
//   document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
// }

// // Function to clear the discount code cookie
// function clearDiscountCodeCookie() {
//   deleteCookie('cart');
//   console.log('Discount code cookie cleared.');
// }

// // Run clearDiscountCodeCookie only once per browser
// if (!localStorage.getItem('discountCookieCleared')) {
//   clearDiscountCodeCookie();
//   localStorage.setItem('discountCookieCleared', 'true');
// }

